import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPauseCircleLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.25 12C2.25 6.61589 6.61481 2.25 12 2.25C17.3852 2.25 21.75 6.61589 21.75 12C21.75 17.3851 17.3851 21.75 12 21.75C6.61487 21.75 2.25 17.3851 2.25 12ZM12 3.75C7.44335 3.75 3.75 7.44421 3.75 12C3.75 16.5567 7.44329 20.25 12 20.25C16.5567 20.25 20.25 16.5567 20.25 12C20.25 7.44421 16.5566 3.75 12 3.75Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.90625 8.53516C10.3205 8.53516 10.6562 8.87094 10.6562 9.28516V14.7134C10.6562 15.1276 10.3205 15.4634 9.90625 15.4634C9.49204 15.4634 9.15625 15.1276 9.15625 14.7134V9.28516C9.15625 8.87094 9.49204 8.53516 9.90625 8.53516ZM14.0951 8.53516C14.5093 8.53516 14.8451 8.87094 14.8451 9.28516V14.7134C14.8451 15.1276 14.5093 15.4634 14.0951 15.4634C13.6809 15.4634 13.3451 15.1276 13.3451 14.7134V9.28516C13.3451 8.87094 13.6809 8.53516 14.0951 8.53516Z",
		fill: "currentColor"
	})]
});
export default SvgPauseCircleLine;
